import { Space, Tag } from 'antd';
import React from 'react';
import { renderAppIcon } from './icon';

export const ENABLED_OPTIONS = [
  { label: '启用', value: 1 },
  { label: '停用', value: 0 },
];

export const STAGE_TYPE_OPTIONS = [
  { label: '普通阶段', value: 'normal' },
  { label: '赢单阶段', value: 'won' },
  { label: '输单阶段', value: 'lost' },
];

export const renderEnabledTag = (enabled: boolean | number) =>
  Number(enabled) > 0 ? <Tag color="success">启用</Tag> : <Tag>停用</Tag>;

export const parseCrmRequestError = (error: unknown, fallback: string) => {
  const record = error as {
    data?: { message?: unknown };
    info?: { message?: unknown };
    message?: unknown;
  };
  const raw = record?.data?.message ?? record?.info?.message ?? record?.message;
  if (Array.isArray(raw)) {
    const joined = raw.join('，').trim();
    if (joined) return joined;
  }
  if (typeof raw === 'string' && raw.trim()) {
    return raw.trim();
  }
  return fallback;
};

export const renderColorSwatch = (color?: string) => (
  <span
    style={{
      display: 'inline-block',
      width: 12,
      height: 12,
      borderRadius: 999,
      background: color || 'transparent',
      border: color
        ? '1px solid var(--ant-color-border-secondary)'
        : '1px dashed var(--ant-color-border)',
      flexShrink: 0,
    }}
  />
);

export const renderColoredName = (
  name: string,
  color?: string,
  description?: string,
  icon?: string,
) => (
  <Space size={8} align="start">
    {renderColorSwatch(color)}
    {icon ? (
      <span style={{ display: 'inline-flex', marginTop: 2 }}>
        {renderAppIcon(icon, 16)}
      </span>
    ) : null}
    <div style={{ minWidth: 0 }}>
      <div>{name}</div>
      {description ? (
        <div
          style={{
            color: 'var(--ant-color-text-tertiary)',
            fontSize: 12,
            lineHeight: 1.5,
          }}
        >
          {description}
        </div>
      ) : null}
    </div>
  </Space>
);

export const sortBySortOrder = <T extends { sortOrder?: number | null }>(
  items: T[],
  getTieBreaker?: (item: T) => string,
) =>
  [...items].sort((left, right) => {
    const diff = Number(left.sortOrder ?? 0) - Number(right.sortOrder ?? 0);
    if (diff !== 0) {
      return diff;
    }
    if (!getTieBreaker) {
      return 0;
    }
    return getTieBreaker(left).localeCompare(
      getTieBreaker(right),
      'zh-Hans-CN',
    );
  });

export const reorderByDirection = <T extends { uuid: string }>(
  items: T[],
  currentUuid: string,
  direction: 'up' | 'down',
) => {
  const currentIndex = items.findIndex((item) => item.uuid === currentUuid);
  if (currentIndex < 0) {
    return null;
  }

  const targetIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;
  if (targetIndex < 0 || targetIndex >= items.length) {
    return null;
  }

  const reordered = [...items];
  const [moved] = reordered.splice(currentIndex, 1);
  reordered.splice(targetIndex, 0, moved);
  return reordered;
};
